import axios from "axios";
import { getToken } from "./auth";


const baseUrl = `${process.env.REACT_APP_API_URL}/api/`

const api = axios.create({
  baseURL: baseUrl
});

api.interceptors.request.use(async config => {
  const token = getToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});



export default api;
